import HistoryCarUsageTable from './HistoryCarUsageTable'

export default HistoryCarUsageTable
